module.exports = __webpack_public_path__ + "img/icons BFr_32.d1c874b2.png";